import { Badge } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { RVDS_BADGES, RvdStatuses, RvdStatusFromBack } from 'shared/enums/rvd';
import { TRvdResponseData } from 'shared/types/rvd.types';

type TProps = {
  rvd?: TRvdResponseData;
};

type TBadgeTexts = 'success' | 'processing' | 'error' | 'default' | 'warning';

const BadgeData: FC<TProps> = ({ rvd }) => {
  const [text, setText] = useState<RvdStatuses>(RvdStatuses.LOADED_CPRODUCT);
  const [badgeData, setBadgeData] = useState<TBadgeTexts>('default');

  useEffect(() => {
    if (!rvd) {
      return;
    }
    setBadgeData(RVDS_BADGES[rvd?.status]);
    setText(RvdStatusFromBack[rvd?.status]);
  }, [rvd]);

  return (
    <span title={rvd?.comment || ''}>
      <Badge status={badgeData} />
      {text}
    </span>
  );
};

export default BadgeData;
